module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filePreview"
  }, [_c('div', {
    staticClass: "previewPrint"
  }, [_c('div', {
    staticClass: "preview-flip-container p-b-20"
  }, [_c('div', {
    staticClass: "flipper"
  }, [(_vm.hasFronts()) ? _c('div', {
    staticClass: "front"
  }, [_c('div', {
    staticClass: "preview frontpreview"
  }, [_c('div', {
    staticClass: "previewMask1 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('foil_front'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewMask2 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('spot_uv_front'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewTrim boxsize"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('front'),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.hasBacks()) ? _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "preview backpreview"
  }, [_c('div', {
    staticClass: "previewMask1 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('foil_back'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewMask2 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('spot_uv_back'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewTrim boxsize"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('back'),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.hasFronts() && _vm.hasBacks()) ? _c('div', {
    staticClass: "previewControls group row m-b-20"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e()]), _vm._v(" "), (_vm.hasFoil() || _vm.hasSpot()) ? _c('div', {
    staticClass: "previewViews group"
  }, [(_vm.hasSpot()) ? _c('div', {
    staticClass: "viewBtns m-b-20"
  }, [_c('div', {
    staticClass: "checkbox m-r-15"
  }, [_c('input', {
    staticClass: "spotuvmask",
    attrs: {
      "type": "checkbox",
      "id": "spotuvmask",
      "name": "spotuvmask"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "spotuvmask",
    attrs: {
      "for": "spotuvmask"
    },
    on: {
      "click": function($event) {
        _vm.toggle('.previewMask2')
      }
    }
  }, [_vm._v("\n                    Show Spot UV Mask\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasFoil()) ? _c('div', {
    staticClass: "viewBtns m-b-20"
  }, [_c('div', {
    staticClass: "checkbox m-r-15"
  }, [_c('input', {
    staticClass: "foilmask",
    attrs: {
      "type": "checkbox",
      "id": "foilmask",
      "name": "foilmask"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "foilmask",
    attrs: {
      "for": "foilmask"
    },
    on: {
      "click": function($event) {
        _vm.toggle('.previewMask1')
      }
    }
  }, [_vm._v("\n                    Show Foil Mask\n                ")])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewLabel text-center p-10 block"
  }, [_c('strong', [_vm._v("Front")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewLabel text-center p-10 block"
  }, [_c('strong', [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success viewfront block"
  }, [_vm._v("View Front")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary primarybg hover primaryborder viewback block"
  }, [_vm._v("View Back")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1df7db2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FilePreview.vue
// module id = 330
// module chunks = 0